module.exports = __webpack_public_path__ + "img/fi-roundup-1200x790.c74d0710.jpg";